export const campaignConfig = {
    campaignListConfig: 'campaign_devapp', // campaign_devapp
};

export const dashboardConfig = {
    mainDashboard: '',
};

export const categoryConfig = {
    menuCategory: 'menu_devapp',
};

export const historyConfig = {
    purchase: 'purchase',
};

export const couponConfig = {
    coupon: 'coupon_config',
};

export const EarnPointHistoryMessageKey = {
    Default: "default",
    Adjust: {
        add: "adjust-add",
        deduct: "adjust-deduct"
    },
    // custom key
    // must config with trace plan id here
    TracePlan: {
        welcomePoint: "trace-welcome",
        survey: "trace-survey",
        friendGetFriend: "trace-fgf"
    }
}
